import React, { useState } from 'react';
import { generateContent } from '../utils/groqClient';
import { validateContent, addDisclaimer } from '../utils/validators';

const DoctorForm = ({ onContentGenerated, setLoading }) => {
  const [formData, setFormData] = useState({
    doctorName: '',
    speciality: '',
    city: '',
    platforms: [],
    contentType: '',
    language: 'English'
  });

  const specialities = ['Cardiologist', 'Dermatologist', 'Orthopedic', 'Pediatrician', 
    'Gynecologist', 'General Physician', 'ENT Specialist', 'Diabetologist'];
  
  const cities = ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Pune', 
    'Kolkata', 'Ahmedabad', 'Thane', 'Jaipur'];
  
  const platforms = ['Instagram', 'WhatsApp', 'Email', 'LinkedIn', 'Facebook', 'YouTube'];
  
  const contentTypes = ['Educational Post', 'Awareness Post', 'Myth vs Fact', 
    'Preventive Health Tip', 'Seasonal Health Advice', 'FAQ', 'Short Video Script'];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePlatform = (platform) => {
    setFormData(prev => ({
      ...prev,
      platforms: prev.platforms.includes(platform)
        ? prev.platforms.filter(p => p !== platform)
        : [...prev.platforms, platform]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.platforms.length === 0) {
      alert('Please select at least one platform');
      return;
    }

    setLoading(true);
    
    try {
      const content = await generateContent(formData);
      const validation = validateContent(content);
      
      if (!validation.isValid) {
        alert(validation.message);
        setLoading(false);
        return;
      }

      const finalContent = addDisclaimer(content);
      onContentGenerated(finalContent);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form">
      <h2>🏥 Medical Content Generator</h2>
      
      <div className="field">
        <label>Doctor Name *</label>
        <input
          type="text"
          name="doctorName"
          placeholder="e.g., Rajesh Kumar"
          value={formData.doctorName}
          onChange={handleChange}
          required
        />
      </div>

      <div className="field">
        <label>Speciality *</label>
        <select name="speciality" value={formData.speciality} onChange={handleChange} required>
          <option value="">Select Speciality</option>
          {specialities.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="field">
        <label>City *</label>
        <select name="city" value={formData.city} onChange={handleChange} required>
          <option value="">Select City</option>
          {cities.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div className="field">
        <label>Select Platforms *</label>
        <div className="platforms">
          {platforms.map(p => (
            <button
              key={p}
              type="button"
              className={formData.platforms.includes(p) ? 'active' : ''}
              onClick={() => togglePlatform(p)}
            >
              {p}
            </button>
          ))}
        </div>
      </div>

      <div className="field">
        <label>Content Type *</label>
        <select name="contentType" value={formData.contentType} onChange={handleChange} required>
          <option value="">Select Type</option>
          {contentTypes.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>

      <div className="field">
        <label>Language</label>
        <div className="radio">
          {['English', 'Hinglish', 'Simple English'].map(lang => (
            <label key={lang}>
              <input
                type="radio"
                name="language"
                value={lang}
                checked={formData.language === lang}
                onChange={handleChange}
              />
              {lang}
            </label>
          ))}
        </div>
      </div>

      <button type="submit" className="btn">✨ Generate Content</button>
    </form>
  );
};

export default DoctorForm;
